import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./school-pro.css";
import App from "./App";

// Pages live at the site root (/login, /dashboard, ...); only the built files (JS/CSS/images) are served
// under PUBLIC_URL (/login) — see package.json "homepage" and the gateway's route table in app/main.py.
ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
